// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__2gd8z","colMin":"styles_colMin__2CrrG","colCheckbox":"styles_colCheckbox__1N0Nz"};